import { memo, type PropsWithChildren, type RefObject } from 'react';

import { type Box } from '@air/react-drag-to-select';

import { MultiselectKeys } from '~/components/MultiselectKeys';
import { type UseMouseSelectionParams, useMouseSelection } from '~/hooks/useMouseSelection';
import { type SelectableGalleryItem } from '~/store/selectedItems/types';

export type MouseSelectableItem = {
  box: Box;
  selectableItem: SelectableGalleryItem | null;
};

export type MouseSelectionContainerProps = {
  containerRef: RefObject<HTMLElement>;
  itemsPositions: MouseSelectableItem[];
  scrollElementRef: UseMouseSelectionParams['scrollElementRef'];
  minSelectionTopPosition?: UseMouseSelectionParams['minSelectionTopPosition'];
};

export const MouseSelectionContainer = memo(
  ({
    children,
    containerRef,
    itemsPositions,
    scrollElementRef,
    minSelectionTopPosition,
  }: PropsWithChildren<MouseSelectionContainerProps>) => {
    const { DragSelection } = useMouseSelection({
      containerRef,
      rowsPositions: itemsPositions,
      scrollElementRef,
      minSelectionTopPosition,
    });

    return (
      <>
        <DragSelection />
        {children}
        <MultiselectKeys />
      </>
    );
  },
);

MouseSelectionContainer.displayName = 'MouseSelectionContainer';
